import React from "react";
import styled from "styled-components";
import { SecondaryButton } from "../UI/Button/Button";
import { Device } from "../../../components/device";
import SafeHtml from "../../../components/Html/SafeHtml";
import { A } from "../GlobalStyle/Utilities";
import Anchor from "../../../components/Router/Anchor";
import { FooterRichText, FooterShortcuts } from "../../../typings/document-types";
import { Link } from "../../../typings/typings";
import {footerItems} from "../../../mock";

const FooterWrap = styled.footer`
    position: relative;
    a:not(.btn) {
        margin-bottom: 10px;
        ${A}
        ${Device.laptop} {
            margin-bottom: 5px;
        }
    }

    .footer__newsletter-mobile {
        > a { width: 100%; }
        ${Device.tablet} {
            display: none;
        }
    }
    .footer__newsletter-desktop {
        > a {
            width: 100%;
            ${Device.tablet} {
                width: auto;
            }
        }
        display: none;
        ${Device.tablet} {
            display: inline-block;
        }
    }
    .anchor-icon:hover {
        color: black;
    }
`;

interface FooterProps
{
    footerItems: (FooterRichText | FooterShortcuts)[];
}

const Footer = (props: FooterProps) =>
{
    const getFooterBody = (footerItem: FooterRichText | FooterShortcuts) =>
    {
        switch (footerItem._contentType)
        {
            case "footerRichText":
                return (<SafeHtml html={footerItem.bodyText} />);
            case "footerShortcuts": {
                const { shortcuts, button } = footerItem;

                return (
                    <>
                        {shortcuts?.map((link: Link, index) =>
                        {
                            return (
                                <span key={index} className="block">
                                    <Anchor to={link.route?.path || link.url} target={link.target}>{link.title || link.name}</Anchor>
                                </span>
                            );
                        })}
                        {button?.map((btn, index) =>
                        {
                            const { link } = btn;
                            if (link)
                            {
                                return <SecondaryButton key={`btn_${index}`} as={Anchor} to={link?.url} className="mt-4">{link.name}</SecondaryButton>;
                            }
                            return null;
                        })}
                    </>
                );
            }
        }
    };

    return (
        <FooterWrap className="text-gray-50 text-small">
            <div className="container mx-auto py-8 sm:py-12 flex flex-wrap">
                {props.footerItems?.map((footerItem, index) =>
                {
                    return (<div key={index} className="w-full sm:w-1/2 lg:w-1/4 mb-8 lg:mb-0 px-4">
                        {footerItem.heading ?
                            <h6 className="uppercase text-em font-bold text-black tracking-wide">{footerItem.heading}</h6>
                            : null}
                        {getFooterBody(footerItem)}
                    </div>);
                })}
            </div>
        </FooterWrap>
    );
};

export default Footer;